import { render, staticRenderFns } from "./TrainingServices.vue?vue&type=template&id=7977b756&scoped=true&"
import script from "./TrainingServices.vue?vue&type=script&lang=js&"
export * from "./TrainingServices.vue?vue&type=script&lang=js&"
import style0 from "./TrainingServices.vue?vue&type=style&index=0&id=7977b756&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7977b756",
  null
  
)

export default component.exports